// hooks/usePreventHorizontalScroll.js

import { useEffect } from 'react';

/**
 * 전역 HTML body 요소에 overflow-x: hidden 스타일을 적용하여
 * 페이지 전체의 가로 스크롤이 발생하는 것을 방지하는 Custom Hook입니다.
 * * 컴포넌트가 마운트될 때 스타일을 적용하고, 언마운트될 때 원래 상태로 복구합니다.
 */
const usePreventHorizontalScroll = () => {
    useEffect(() => {
        // 컴포넌트가 마운트될 때, 현재 body의 overflow-x 상태를 저장합니다.
        const originalOverflowX = document.body.style.overflowX;

        // body에 overflow-x: hidden을 적용하여 가로 스크롤을 막습니다.
        document.body.style.overflowX = 'hidden';

        // 클린업 함수: 컴포넌트가 언마운트되거나 의존성이 변경될 때 호출됩니다.
        return () => {
            // body의 overflow-x 속성을 원래 상태로 복구합니다.
            document.body.style.overflowX = originalOverflowX;
        };
    }, []); // 빈 배열: 마운트 시 1회 실행, 언마운트 시 1회 클린업 실행
};

export default usePreventHorizontalScroll;